import BoasVindasEstoqueView from "../../components/estoque/BoasVindasEstoqueView";

export default function BoasVindasEstoque() {
  return <BoasVindasEstoqueView />;
}
